class ShippingProtection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.toggle = this.querySelector('.shipping-switch__input');

    if (!this.toggle) return;

    this.variantId = this.dataset.variantId;

    window.shippingProtection = {variantId: this.variantId,};

    this.removeIfOnlyItem();

    this.toggle.addEventListener('change', this.onToggle.bind(this));
  }

   removeIfOnlyItem() {
    if (!document.querySelector('cart-items')) return;

    const cartItems = document.querySelectorAll('[data-cart-item-variant-id]');
    if (cartItems.length !== 1) return;
    
    const item = cartItems[0];
    
    console.log(this.variantId);
    console.log(Number(item.dataset.cartItemVariantId));
    if (Number(item.dataset.cartItemVariantId) !== Number(this.variantId)) return;

    item.querySelector('cart-remove-button a')?.click();
  }
  async onToggle(event) {
    if (event.target.checked) {
      await this.addProtection();
    } else {
      await this.removeProtection();
    }
  }

  async addProtection() {
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    if (!cart) {
      window.location.href = `${routes.cart_url}/add?id=${this.variantId}&quantity=1`;
      return;
    }

    const config = fetchConfig('javascript');

    config.headers['X-Requested-With'] = 'XMLHttpRequest';

    delete config.headers['Content-Type'];

    const formData = new FormData();

    formData.append('id', this.variantId);
    formData.append('quantity', 1);

    formData.append(
      'sections',
      cart.getSectionsToRender().map(section => section.id)
    );

    formData.append(
      'sections_url',
      window.location.pathname
    );

    cart.setActiveElement(document.activeElement);

    config.body = formData;

    const response = await fetch(
      routes.cart_add_url,
      config
    ).then(response => response.json());

    if (response.status) {
      this.toggle.checked = false;
      return;
    }
    cart.renderContents(response);
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'shipping-protection', cartData: response });
  }

  async removeProtection() {
    const removeButton = document.querySelector('[data-cart-item-variant-id="' + this.variantId + '"] cart-remove-button button') || document.querySelector('[data-cart-item-variant-id="' + this.variantId + '"] cart-remove-button a.button');
    
    if (!removeButton) {
      window.location.reload();
      return;
    }
    console.log(removeButton);
    removeButton.click();
  }
}

customElements.define('shipping-protection', ShippingProtection);
